import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AngularFireDatabase } from 'angularfire2/database';
import { Observable } from 'rxjs/Rx';

import { MoneyPerApplication } from '../models/money-per-application';
import { MoneyPerMeetup } from '../models/money-per-meetup';
import { AuthService } from './auth.service';

@Injectable()
export class ReportService {

	constructor(private afDatabase: AngularFireDatabase,
		private http: Http,
		private authService: AuthService) { }

	public getMoneyPerCouples(): Observable<MoneyPerApplication[]> {
		return this.afDatabase.list('/applicationsMoney');
	}

	public getMoneyPerCouplesByMeetup(key: string): Observable<MoneyPerApplication[]> {
		return this.afDatabase.list('/applicationsMoney', {
			query: {
				orderByChild: 'meetup',
				equalTo: key
			}
		});
	}

	public getMoneyPerMeetups(): Observable<MoneyPerMeetup[]> {
		return this.afDatabase.list('/meetupsMoney');
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/services/report.service.ts